import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'utils/constants';

// EVI-87 only ever issues path=/auth/verify. Anything else is a mistake or an
// attempt to aim this route somewhere else while the magic-link token rides
// along in the query string, so the destination is allowlisted outright
// rather than validated. Add entries here if more destinations are needed.
const ALLOWED_PATHS = [ROUTES.AUTH_VERIFY];

// Landing page for the /go/native links in magic-link emails sent to IOS and
// ANDROID (EVI-87 picks the URL at issue time; EVI-88 claims the path in the
// app). When the app is installed the OS intercepts the URL and this page
// never renders, so if it does render the app is missing — or the link opened
// in an in-app browser that ignores app links. Either way, forward to the web
// verify flow so the link never dead-ends.
const GoNative = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const requested = params.get('path') || ROUTES.AUTH_VERIFY;
    const path = ALLOWED_PATHS.includes(requested) ? requested : ROUTES.AUTH_VERIFY;

    params.delete('path');
    const query = params.toString();
    window.location.replace(query ? `${path}?${query}` : path);
  }, [search]);

  return null;
};

export default GoNative;
